// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import IconAddToList from "@pace/XDL/Icons/IconAddToList";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, createLinkIconStyles } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productAddToListLinkStyles.link = {
    ...createLinkIconStyles(IconAddToList, {
        typographyProps: {
            size: 12,
            weight: fontConfig.weight.bold,
            css: css`
                letter-spacing: 0;
                line-height: 13px;
            `,
        },
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    circle {
                        stroke: ${color("common.border")};
                    }
                `,
            },
            position: "left",
        },
    }),
};
